<template>
  <span class="ai-visibility-source-avatar">
    <img
      v-if="avatarSrc && !avatarLoadFailed"
      :src="avatarSrc"
      alt=""
      @error="handleImageError"
    />
    <span v-else>{{ initials }}</span>
  </span>
</template>

<script>
export default {
  name: 'SourceAvatar',
  data () {
    return {
      avatarLoadFailed: false,
    }
  },
  props: {
    domain: {
      type: String,
      default: '',
    }
  },
  computed: {
    avatarSrc () {
      return this.domain ? `https://${this.domain}/favicon.ico` : ''
    },
    initials () {
      const cleanLabel = this.domain.trim()
      if (!cleanLabel) {
        return '?'
      }
      return cleanLabel
        .split(/\s+|[.-]/)
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0).toUpperCase())
        .join('')
    },
  },
  watch: {
    label () {
      this.avatarLoadFailed = false
    },
  },
  methods: {
    handleImageError () {
      this.avatarLoadFailed = true
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-source-avatar {
  display: inline-flex;
  overflow: hidden;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--v-lightYellowColor-base);
  color: var(--v-profileAnchorColor-base);
  flex: 0 0 36px;
  font-size: 12px;
  font-weight: 800;
}

.ai-visibility-source-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ai-visibility-source-avatar--muted {
  background: var(--v-gray10Color-base);
  color: var(--v-gray50Color-base);
}
</style>
